module.exports = __webpack_public_path__ + "static/media/admin_plugin_tomcat.adb79652.svg";